// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fileTimeline::-webkit-scrollbar{display:block;width:4px}.fileTimeline::-webkit-scrollbar-thumb{background-color:#1f50ab;border-radius:5px}.fileTimeline::-webkit-scrollbar-track{background-color:#e2e8f0;border-radius:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
